















import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { UploadOptData, fileServer } from '@/api/common/upload'
import { AttachInfo, getList, remove } from '@/api/common/attach'
import { newGuid } from '@/configs/functions'

@Component
export default class multiFile extends Vue {
  @Prop({ default: false })
  public viewModel!: boolean
  @Prop({ default: 0 })
  public referId!: number
  @Prop({ default: 0 })
  public referType!: number
  @Prop({ default: '' })
  public tempGuid!: string
  @Prop({ default: '' })
  public fileExt!: string

  //每次调用组件都生成一个guid，用来在上传完成后的回传
  public uploadGuid: string = ''
  get opts(): UploadOptData {
    return {
      isMulti: true, //是否支持多个附件，以列表展示
      exts: this.fileExt, //格式限制 .pdf.doc.docx.png.jpg.gif
      refId: this.referId,
      refType: this.referType, // 从后台获取，refType=(byte)EnumHelper.AttachType.对应枚举
      guid: this.tempGuid // newGuid() // 从后台获取，guid=Guid.NewGuid().ToString()
    }
  }
  public fileList: AttachInfo[] = []

  public getFileUrl(f: AttachInfo) {
    return fileServer(f.Id, f.TempGuid, f.Name)
  }
  //后端如果有直接返回附件列表，就调用这个方法，直接设置附件，这样就不要单独查询了
  public setData(data: AttachInfo[]) {
    this.fileList = []
    this.fileList = data
  }
  public getData() {
    return this.fileList
  }
  public getFileList() {
    var opt = this.opts
    if ((opt.refType > 0 && opt.refId > 0) ||
      (opt.refType > 0 && opt.guid != '')) {
      getList(opt.refId, opt.refType, opt.guid).then(
        (response: { data: any }) => {
          this.fileList = response.data
          this.refresh()
        }
      )
    }
  }
  public refresh() {
    this.$emit('fileChange', { opts: this.opts, files: this.fileList })
  }
  public created() {
    if (this.uploadGuid == '') {
      this.uploadGuid = newGuid()
    }
  }
  public mounted() {
    window.eventBus.$on('uploadComplete', (info: any) => {
      if (info.targetId == this.uploadGuid) {
        // this.opts = info.opt
        this.getFileList()
      }
    })

    this.$nextTick(() => {
      this.getFileList()
    })
  }
  public beforeDestroy() {
    window.eventBus.$off('uploadComplete')
  }
  //打开上传组件
  public showUploader() {
    if (this.uploadGuid == '') {
      this.uploadGuid = newGuid()
    }
    window.eventBus.$emit('openUploader', {
      targetId: this.uploadGuid,
      opt: this.opts
    })
  }
  public delFile(index: number) {
    let f = this.fileList[index]
    const id = f.Id
    if (id > 0) {
      this.$confirm(`此操作将永久删除该文件, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          remove(id).then(() => {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.fileList.splice(index, 1)
            // this.$set(this.fileList, index, f)
            this.refresh()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    }
  }
}
